var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('Button',{staticClass:"color-link",attrs:{"type":_vm.color,"link":"","hasIcon":_vm.hasIcon,"outlined":_vm.outlined}},[_c('AcfLink',{attrs:{"data":_vm.link}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }